/* ==========================================================================
   god-fix : clamp quantity input in the bulk quick order popup

   Problem
   -------
   quick-order-list.js does this on change:

     onChange(event) {
       const inputValue = parseInt(event.target.value);          // raw, unvalidated
       const snapshot = this.applyOptimisticUpdate(variantId, inputValue);
       inputValue == 0 ? this.startQueue(...) : this.validateQuantity(event);
     }

   applyOptimisticUpdate() runs BEFORE validateQuantity(), so "Total items"
   and "Product subtotal" are recalculated from the raw typed number. When
   validation then fails, BulkAdd.setValidity() -> resetQuantityInput() puts the
   INPUT back to its previous value but never rolls the totals back. Result:
   type 33333, blur, and the field shows 0 while the totals show 33333 and a
   subtotal of 858324.75.

   resetQuantityInput() also restores the previous value rather than the limit,
   so 1000 never becomes 20 the way the PDP selector behaves.

   Fix
   ---
   Wrap onChange on the prototype and clamp event.target.value into the allowed
   range first. Everything downstream - the optimistic totals, validateQuantity
   and the /cart/update.js payload - then reads the same valid number, so the
   field, Total items and Product subtotal always agree and never exceed the
   real maximum.

   Patching the prototype covers instances that already exist, because
   handleQuantityChange() resolves this.onChange at call time.
   ========================================================================== */
(function () {
  function clampInput(input) {
    if (!input || input.type !== 'number') return;

    var raw = parseInt(input.value, 10);
    if (isNaN(raw)) return;
    if (raw <= 0) return; // 0 means "remove from cart" and is always allowed

    var min = parseInt(input.dataset.min, 10);
    if (isNaN(min) || min < 1) min = 1;

    var maxAttr = input.getAttribute('max');
    var max = maxAttr === null || maxAttr === '' ? null : parseInt(maxAttr, 10);
    if (max !== null && isNaN(max)) max = null;

    var step = parseInt(input.getAttribute('step'), 10);
    if (isNaN(step) || step < 1) step = 1;

    var value = raw;

    if (max !== null && value > max) value = max;
    if (value < min) value = min;

    // Snap to a valid step offset from the minimum, staying inside the range.
    if (step > 1) {
      value = min + Math.floor((value - min) / step) * step;
      if (max !== null && value > max) value -= step;
      if (value < min) value = min;
    }

    if (value !== raw) input.value = value;
  }

  function patch() {
    var registry = window.customElements;
    if (!registry || typeof registry.get !== 'function') return false;

    var QuickOrderList = registry.get('quick-order-list');
    if (!QuickOrderList || !QuickOrderList.prototype) return false;
    if (QuickOrderList.prototype.__godClampPatched) return true;

    var original = QuickOrderList.prototype.onChange;
    if (typeof original !== 'function') return false;

    QuickOrderList.prototype.onChange = function (event) {
      if (event) clampInput(event.target);
      return original.call(this, event);
    };
    QuickOrderList.prototype.__godClampPatched = true;
    return true;
  }

  // quick-order-list.js is loaded by the section, so it may define the element
  // before or after this file runs. Cover both, then stop.
  if (patch()) return;

  if (window.customElements && typeof customElements.whenDefined === 'function') {
    customElements.whenDefined('quick-order-list').then(patch);
  }
  document.addEventListener('DOMContentLoaded', patch);

  var attempts = 0;
  var timer = setInterval(function () {
    if (patch() || ++attempts > 60) clearInterval(timer);
  }, 100);
})();
